import { ContactsApiProvider } from './contactsapi.services';

export const addDocumentMapping = (documentMapping) => {
  return ContactsApiProvider.post('/documentmapping/', documentMapping);
};

export const updateDocumentMapping = (documentMapping) => {
  return ContactsApiProvider.put('/documentmapping/', documentMapping);
};

export const getDocumentMappingsForContact = (contactId) => {
  return ContactsApiProvider.get(`/documentmapping/contacts/${contactId}/`);
};

export const getDocumentMappingsForOpportunity = (opportunityId) => {
  return ContactsApiProvider.get(`/documentmapping/opportunities/${opportunityId}/`);
};
